import { useEffect, useRef, useState } from "react";
import Nav1 from "../components/header/Nav1";
import Nav2 from "../components/header/Nav2";
import Nav3 from "../components/header/Nav3";
import { useCart } from "../contexts/CartContext";
import { useNav } from "../contexts/NavContext";
import Cart from "../features/cart/Cart";
import Sidebar from "./Sidebar";

function Header() {
  // Contexts
  const { setNav2Content, isSidebarOpen } = useNav();
  const { cartOpen } = useCart();

  // Refs
  const headerRef = useRef(null);

  // States
  const [scrolled, setScrolled] = useState(false);
  const [category, setCategory] = useState("");

  // Effects
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setNav2Content(false);
      }
    };

    document.addEventListener("mousemove", handleMouseLeave);

    return () => document.removeEventListener("mousemove", handleMouseLeave);
  }, [setNav2Content]);

  useEffect(() => {
    cartOpen
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [cartOpen]);

  return (
    <div ref={headerRef} className="fixed z-50 w-full shadow-2xl">
      {/* 1st Nav */}
      <Nav1 scrolled={scrolled} />

      {/* 2nd Nav */}
      <Nav2 scrolled={scrolled} setCategory={setCategory} />

      {/* SecondNav Content Box (3rd Nav) */}
      <Nav3 scrolled={scrolled} category={category} />

      {/* Sidebar box component */}
      {isSidebarOpen && <Sidebar />}

      {/* Cart Box component */}
      {cartOpen && <Cart />}
    </div>
  );
}

export default Header;
